import { createReducer } from 'reduxsauce';

import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  SET_USER_LANGUAGE,
  FETCH_USER_COMMUNITIES_REQUEST,
  FETCH_USER_COMMUNITIES_FAILURE,
  FETCH_USER_COMMUNITIES_SUCCESS
} from '../../actions/user/userActions';

export const INITIAL_STATE = {
  error: false,
  errorMessage: null,
  isFetching: false,
  requests: {
    communities: {
      success: false,
      error: false,
      errorMessage: null,
      isFetching: false
    }
  }
};

export const fetchUserRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isFetching: true,
    error: false
  };
};

export const fetchUserCommunitiesRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isFetching: true,
    error: false,
    requests: {
      ...state.requests,
      communities: {
        ...state.requests.communities,
        success: false,
        error: false,
        errorMessage: null,
        isFetching: true
      }
    }
  };
};

export const fetchUserCommunitiesSuccess = (state = INITIAL_STATE, action) => {
  const {
    payload: { myCommunities }
  } = action;

  return {
    ...state,
    myCommunities,
    error: false,
    isFetching: false,
    requests: {
      ...state.requests,
      communities: {
        ...state.requests.communities,
        success: true,
        error: false,
        errorMessage: null,
        isFetching: false
      }
    }
  };
};

export const fetchUserSuccess = (state = INITIAL_STATE, action) => {
  const {
    payload: { user }
  } = action;

  return {
    ...state,
    ...user,
    error: false,
    isFetching: false
  };
};

export const fetchUserFailure = (state = INITIAL_STATE, action) => {
  const {
    payload: {
      response: { problem }
    }
  } = action;

  return {
    ...state,
    error: true,
    errorMessage: problem,
    isFetching: false
  };
};

export const fetchUserCommunitiesFailure = (state = INITIAL_STATE, action) => {
  const {
    payload: {
      response: { problem }
    }
  } = action;

  return {
    ...state,
    error: true,
    errorMessage: problem,
    isFetching: false,
    requests: {
      ...state.requests,
      communities: {
        ...state.requests.communities,
        success: false,
        error: true,
        errorMessage: problem,
        isFetching: false
      }
    }
  };
};

export const setUserLanguage = (state = INITIAL_STATE, action) => {
  const {
    payload: { language }
  } = action;

  return {
    ...state,
    userLanguage: language
  };
};

export default createReducer(INITIAL_STATE, {
  [FETCH_USER_REQUEST]: fetchUserRequest,
  [FETCH_USER_SUCCESS]: fetchUserSuccess,
  [FETCH_USER_FAILURE]: fetchUserFailure,
  [SET_USER_LANGUAGE]: setUserLanguage,
  [FETCH_USER_COMMUNITIES_REQUEST]: fetchUserCommunitiesRequest,
  [FETCH_USER_COMMUNITIES_FAILURE]: fetchUserCommunitiesFailure,
  [FETCH_USER_COMMUNITIES_SUCCESS]: fetchUserCommunitiesSuccess
});
